import React, { useCallback } from 'react';
import { useInput, useTranslate } from 'react-admin';
import { FileDropzone } from '../../../../components/shared/FileDropzone';
import { EXCEL_ACCEPT } from '../../../../core/constants/file.constants';

export const PumpsSpeedForm = () => {
  const t = useTranslate();
  const {
    field: { onChange, value }
  } = useInput({ source: 'file' });

  const file = value?.rawFile || null;

  const handleFileChange = useCallback(
    (f: File | null) => {
      if (f) {
        onChange({
          rawFile: f,
          src: URL.createObjectURL(f),
          title: f.name
        });
      } else {
        onChange(null);
      }
    },
    [onChange]
  );

  return (
    <FileDropzone
      accept={EXCEL_ACCEPT}
      file={file}
      onFileChange={handleFileChange}
      label={t('resources.pumps.speeds.fields.file')}
    />
  );
};
